(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel-1"] && !Shopify.designMode) return;
  try {
    
    /**
     * Collection Carousel – Horizon Optimized
     * Lazy‑loads Swiper.js from CDN only when needed.
     */
    (function () {
        'use strict';

        var swiperAssetsLoaded = {
            css: false,
            js: false
        };

        function loadSwiperAssets() {
            return new Promise(function (resolve) {
                if (swiperAssetsLoaded.css && swiperAssetsLoaded.js) {
                    resolve();
                    return;
                }

                var loadedCount = 0;
                function checkDone() {
                    loadedCount++;
                    if (loadedCount === 2) {
                        swiperAssetsLoaded.css = true;
                        swiperAssetsLoaded.js = true;
                        resolve();
                    }
                }

                if (!swiperAssetsLoaded.css) {
                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
                    link.onload = checkDone;
                    link.onerror = checkDone;
                    document.head.appendChild(link);
                } else {
                    checkDone();
                }

                if (!swiperAssetsLoaded.js) {
                    var script = document.createElement('script');
                    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
                    script.onload = checkDone;
                    script.onerror = checkDone;
                    document.head.appendChild(script);
                } else {
                    checkDone();
                }
            });
        }

        function initCarousels() {
            var sections = document.querySelectorAll('[data-section-type="collection-carousel"]');
            if (!sections.length) return;

            sections.forEach(function (section) {
                var swiperEl = section.querySelector('.collection-carousel__swiper');
                if (!swiperEl || swiperEl.swiper) return;

                var mobileCols = parseInt(section.dataset.mobileColumns, 10) || 2;
                var tabletCols = parseInt(section.dataset.tabletColumns, 10) || 3;
                var desktopCols = parseInt(section.dataset.desktopColumns, 10) || 4;
                var autoplay = section.dataset.autoplay === 'true';
                var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4000;
                var showNav = section.dataset.showNavigation !== 'false';
                var showPagination = section.dataset.showPagination !== 'false';

                var slides = swiperEl.querySelectorAll('.swiper-slide');
                var totalSlides = slides.length;
                var maxCols = Math.max(mobileCols, tabletCols, desktopCols);
                var shouldLoop = totalSlides > maxCols;

                var breakpoints = {
                    320: { slidesPerView: mobileCols, spaceBetween: 6 },
                    768: { slidesPerView: tabletCols, spaceBetween: 16 },
                    1024: { slidesPerView: desktopCols, spaceBetween: 20 }
                };
                if (desktopCols >= 6) {
                    breakpoints[1280] = { slidesPerView: desktopCols, spaceBetween: 24 };
                }

                var config = {
                    slidesPerView: mobileCols,
                    spaceBetween: 6,
                    loop: shouldLoop,
                    loopAdditionalSlides: 2,
                    speed: 500,
                    breakpoints: breakpoints,
                    grabCursor: true,
                    touchRatio: 1.2,
                    resistanceRatio: 0.85,
                    keyboard: { enabled: true, onlyInViewport: true },
                    lazy: { loadPrevNext: true, loadPrevNextAmount: 2 },
                    observer: true,
                    observeParents: true
                };

                if (showNav) {
                    var prevEl = section.querySelector('.collection-carousel__prev');
                    var nextEl = section.querySelector('.collection-carousel__next');
                    if (prevEl && nextEl) {
                        config.navigation = {
                            prevEl: prevEl,
                            nextEl: nextEl,
                            disabledClass: 'swiper-button-disabled'
                        };
                    }
                }

                if (showPagination) {
                    var pagEl = section.querySelector('.collection-carousel__pagination');
                    if (pagEl) {
                        config.pagination = {
                            el: pagEl,
                            clickable: true,
                            dynamicBullets: true,
                            dynamicMainBullets: Math.min(totalSlides, 5)
                        };
                    }
                }

                if (autoplay && totalSlides > 1) {
                    config.autoplay = {
                        delay: autoplaySpeed,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true,
                        stopOnLastSlide: false
                    };
                }

                var swiperInstance = new Swiper(swiperEl, config);
                swiperEl.swiper = swiperInstance;

                // Update loop on resize if needed
                var resizeTimer;
                function handleResize() {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        var width = window.innerWidth;
                        var cols = desktopCols;
                        if (width < 768) cols = mobileCols;
                        else if (width < 1024) cols = tabletCols;

                        var shouldLoopNow = totalSlides > cols;
                        if (swiperInstance.params.loop !== shouldLoopNow) {
                            swiperInstance.params.loop = shouldLoopNow;
                            swiperInstance.destroy(true, true);
                            var newConfig = Object.assign({}, config, { loop: shouldLoopNow });
                            var newSwiper = new Swiper(swiperEl, newConfig);
                            swiperEl.swiper = newSwiper;
                        }
                    }, 250);
                }

                if (window.ResizeObserver) {
                    var ro = new ResizeObserver(function () { handleResize(); });
                    ro.observe(swiperEl);
                    swiperEl._resizeObserver = ro;
                } else {
                    window.addEventListener('resize', handleResize);
                    swiperEl._resizeListener = handleResize;
                }
            });
        }

        function observeSections() {
            var sections = document.querySelectorAll('[data-section-type="collection-carousel"]');
            if (!sections.length) return;

            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var section = entry.target;
                        loadSwiperAssets().then(function () {
                            var swiperEl = section.querySelector('.collection-carousel__swiper');
                            if (swiperEl && !swiperEl.swiper) {
                                initCarousels();
                            }
                        });
                        observer.unobserve(section);
                    }
                });
            }, { rootMargin: '200px 0px', threshold: 0.01 });

            sections.forEach(function (section) {
                var rect = section.getBoundingClientRect();
                var isVisible = rect.top < window.innerHeight + 200 && rect.bottom > -200;
                if (isVisible) {
                    loadSwiperAssets().then(function () {
                        var swiperEl = section.querySelector('.collection-carousel__swiper');
                        if (swiperEl && !swiperEl.swiper) {
                            initCarousels();
                        }
                    });
                } else {
                    observer.observe(section);
                }
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', observeSections);
        } else {
            observeSections();
        }

        document.addEventListener('shopify:section:load', function (event) {
            var section = event.target.closest('[data-section-type="collection-carousel"]');
            if (section) {
                var swiperEl = section.querySelector('.collection-carousel__swiper');
                if (swiperEl) {
                    if (swiperEl.swiper) {
                        swiperEl.swiper.destroy(true, true);
                        delete swiperEl.swiper;
                    }
                    if (swiperEl._resizeObserver) {
                        swiperEl._resizeObserver.disconnect();
                        delete swiperEl._resizeObserver;
                    }
                    if (swiperEl._resizeListener) {
                        window.removeEventListener('resize', swiperEl._resizeListener);
                        delete swiperEl._resizeListener;
                    }
                }
                loadSwiperAssets().then(function () { initCarousels(); });
            }
        });

        document.addEventListener('shopify:section:unload', function (event) {
            var section = event.target.closest('[data-section-type="collection-carousel"]');
            if (section) {
                var swiperEl = section.querySelector('.collection-carousel__swiper');
                if (swiperEl && swiperEl.swiper) {
                    swiperEl.swiper.destroy(true, true);
                    delete swiperEl.swiper;
                }
                if (swiperEl && swiperEl._resizeObserver) {
                    swiperEl._resizeObserver.disconnect();
                    delete swiperEl._resizeObserver;
                }
                if (swiperEl && swiperEl._resizeListener) {
                    window.removeEventListener('resize', swiperEl._resizeListener);
                    delete swiperEl._resizeListener;
                }
            }
        });

        var resizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                document.querySelectorAll('.collection-carousel__swiper').forEach(function (el) {
                    if (el.swiper) el.swiper.update();
                });
            }, 300);
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
    /**
     * Collection Carousel – Horizon Optimized
     * Lazy‑loads Swiper.js from CDN only when needed.
     */
    (function () {
        'use strict';

        var swiperAssetsLoaded = {
            css: false,
            js: false
        };

        function loadSwiperAssets() {
            return new Promise(function (resolve) {
                if (swiperAssetsLoaded.css && swiperAssetsLoaded.js) {
                    resolve();
                    return;
                }

                var loadedCount = 0;
                function checkDone() {
                    loadedCount++;
                    if (loadedCount === 2) {
                        swiperAssetsLoaded.css = true;
                        swiperAssetsLoaded.js = true;
                        resolve();
                    }
                }

                if (!swiperAssetsLoaded.css) {
                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
                    link.onload = checkDone;
                    link.onerror = checkDone;
                    document.head.appendChild(link);
                } else {
                    checkDone();
                }

                if (!swiperAssetsLoaded.js) {
                    var script = document.createElement('script');
                    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
                    script.onload = checkDone;
                    script.onerror = checkDone;
                    document.head.appendChild(script);
                } else {
                    checkDone();
                }
            });
        }

        function initCarousels() {
            var sections = document.querySelectorAll('[data-section-type="collection-carousel"]');
            if (!sections.length) return;

            sections.forEach(function (section) {
                var swiperEl = section.querySelector('.collection-carousel__swiper');
                if (!swiperEl || swiperEl.swiper) return;

                var mobileCols = parseInt(section.dataset.mobileColumns, 10) || 2;
                var tabletCols = parseInt(section.dataset.tabletColumns, 10) || 3;
                var desktopCols = parseInt(section.dataset.desktopColumns, 10) || 4;
                var autoplay = section.dataset.autoplay === 'true';
                var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4000;
                var showNav = section.dataset.showNavigation !== 'false';
                var showPagination = section.dataset.showPagination !== 'false';

                var slides = swiperEl.querySelectorAll('.swiper-slide');
                var totalSlides = slides.length;
                var maxCols = Math.max(mobileCols, tabletCols, desktopCols);
                var shouldLoop = totalSlides > maxCols;

                var breakpoints = {
                    320: { slidesPerView: mobileCols, spaceBetween: 12 },
                    768: { slidesPerView: tabletCols, spaceBetween: 16 },
                    1024: { slidesPerView: desktopCols, spaceBetween: 20 }
                };
                if (desktopCols >= 6) {
                    breakpoints[1280] = { slidesPerView: desktopCols, spaceBetween: 24 };
                }

                var config = {
                    slidesPerView: mobileCols,
                    spaceBetween: 12,
                    loop: shouldLoop,
                    loopAdditionalSlides: 2,
                    speed: 500,
                    breakpoints: breakpoints,
                    grabCursor: true,
                    touchRatio: 1.2,
                    resistanceRatio: 0.85,
                    keyboard: { enabled: true, onlyInViewport: true },
                    lazy: { loadPrevNext: true, loadPrevNextAmount: 2 },
                    observer: true,
                    observeParents: true
                };

                if (showNav) {
                    var prevEl = section.querySelector('.collection-carousel__prev');
                    var nextEl = section.querySelector('.collection-carousel__next');
                    if (prevEl && nextEl) {
                        config.navigation = {
                            prevEl: prevEl,
                            nextEl: nextEl,
                            disabledClass: 'swiper-button-disabled'
                        };
                    }
                }

                if (showPagination) {
                    var pagEl = section.querySelector('.collection-carousel__pagination');
                    if (pagEl) {
                        config.pagination = {
                            el: pagEl,
                            clickable: true,
                            dynamicBullets: true,
                            dynamicMainBullets: Math.min(totalSlides, 5)
                        };
                    }
                }

                if (autoplay && totalSlides > 1) {
                    config.autoplay = {
                        delay: autoplaySpeed,
                        // FIX: was `true`, which caused autoplay to permanently stop
                        // the first time a mobile user touched/swiped the carousel
                        // (or even scrolled the page over it). Desktop rarely
                        // triggers this via mouse, so the bug only showed on mobile.
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                        stopOnLastSlide: false
                    };
                }

                var swiperInstance = new Swiper(swiperEl, config);
                swiperEl.swiper = swiperInstance;

                // Update loop on resize if needed
                var resizeTimer;
                function handleResize() {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        var width = window.innerWidth;
                        var cols = desktopCols;
                        if (width < 768) cols = mobileCols;
                        else if (width < 1024) cols = tabletCols;

                        var shouldLoopNow = totalSlides > cols;
                        if (swiperInstance.params.loop !== shouldLoopNow) {
                            swiperInstance.params.loop = shouldLoopNow;
                            swiperInstance.destroy(true, true);
                            var newConfig = Object.assign({}, config, { loop: shouldLoopNow });
                            var newSwiper = new Swiper(swiperEl, newConfig);
                            swiperEl.swiper = newSwiper;
                        }
                    }, 250);
                }

                if (window.ResizeObserver) {
                    var ro = new ResizeObserver(function () { handleResize(); });
                    ro.observe(swiperEl);
                    swiperEl._resizeObserver = ro;
                } else {
                    window.addEventListener('resize', handleResize);
                    swiperEl._resizeListener = handleResize;
                }
            });
        }

        function observeSections() {
            var sections = document.querySelectorAll('[data-section-type="collection-carousel"]');
            if (!sections.length) return;

            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var section = entry.target;
                        loadSwiperAssets().then(function () {
                            var swiperEl = section.querySelector('.collection-carousel__swiper');
                            if (swiperEl && !swiperEl.swiper) {
                                initCarousels();
                            }
                        });
                        observer.unobserve(section);
                    }
                });
            }, { rootMargin: '200px 0px', threshold: 0.01 });

            sections.forEach(function (section) {
                var rect = section.getBoundingClientRect();
                var isVisible = rect.top < window.innerHeight + 200 && rect.bottom > -200;
                if (isVisible) {
                    loadSwiperAssets().then(function () {
                        var swiperEl = section.querySelector('.collection-carousel__swiper');
                        if (swiperEl && !swiperEl.swiper) {
                            initCarousels();
                        }
                    });
                } else {
                    observer.observe(section);
                }
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', observeSections);
        } else {
            observeSections();
        }

        document.addEventListener('shopify:section:load', function (event) {
            var section = event.target.closest('[data-section-type="collection-carousel"]');
            if (section) {
                var swiperEl = section.querySelector('.collection-carousel__swiper');
                if (swiperEl) {
                    if (swiperEl.swiper) {
                        swiperEl.swiper.destroy(true, true);
                        delete swiperEl.swiper;
                    }
                    if (swiperEl._resizeObserver) {
                        swiperEl._resizeObserver.disconnect();
                        delete swiperEl._resizeObserver;
                    }
                    if (swiperEl._resizeListener) {
                        window.removeEventListener('resize', swiperEl._resizeListener);
                        delete swiperEl._resizeListener;
                    }
                }
                loadSwiperAssets().then(function () { initCarousels(); });
            }
        });

        document.addEventListener('shopify:section:unload', function (event) {
            var section = event.target.closest('[data-section-type="collection-carousel"]');
            if (section) {
                var swiperEl = section.querySelector('.collection-carousel__swiper');
                if (swiperEl && swiperEl.swiper) {
                    swiperEl.swiper.destroy(true, true);
                    delete swiperEl.swiper;
                }
                if (swiperEl && swiperEl._resizeObserver) {
                    swiperEl._resizeObserver.disconnect();
                    delete swiperEl._resizeObserver;
                }
                if (swiperEl && swiperEl._resizeListener) {
                    window.removeEventListener('resize', swiperEl._resizeListener);
                    delete swiperEl._resizeListener;
                }
            }
        });

        var resizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                document.querySelectorAll('.collection-carousel__swiper').forEach(function (el) {
                    if (el.swiper) el.swiper.update();
                });
            }, 300);
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
